import { Box, Chip, Grid, SxProps, Theme, Typography } from "@mui/material";
import { getDateString, getRoundStatus } from "../../../../common/RoundHelper";
import kung8 from '../../../../images/kung8.png';
import kung12 from '../../../../images/kung12.png';
import kung13 from '../../../../images/kung13.png';
import video8back from '../../../../images/video_8_background.png';
import video12back from '../../../../images/video_12_background.png';
import video13back from '../../../../images/video_13_background.png';
import video8 from '../../../../images/video8_no_background.png';
import video12 from '../../../../images/video12_no_background.png';
import video13 from '../../../../images/video13_no_background.png';
import mrvegas8back from '../../../../images/mrvegas_13_background.png';
import mrvegas12back from '../../../../images/mrvegas_13_background.png';
import mrvegas13back from '../../../../images/mrvegas_13_background.png';
import mrvegas8 from '../../../../images/mrvegas8_no_background.png';
import mrvegas12 from '../../../../images/mrvegas12_no_background.png';
import mrvegas13 from '../../../../images/mrvegas13_no_background.png';
import mega8 from '../../../../images/mega_8.png';
import mega12 from '../../../../images/mega_12.png';
import mega13 from '../../../../images/mega_13.png';
import comeon8 from '../../../../images/comeon_8.png';
import comeon12 from '../../../../images/comeon_12.png';
import comeon13 from '../../../../images/comeon_13.png';
import comeon7 from '../../../../images/comeon_7.png';
import comeon9 from '../../../../images/comeon_9.png';
import snabbare7 from '../../../../images/snabbare_7.png';
import snabbare9 from '../../../../images/snabbare_9.png';
import snabbare8 from '../../../../images/snabbare_8.png';
import snabbare12 from '../../../../images/snabbare_12.png';
import snabbare13 from '../../../../images/snabbare_13.png';
import reviantBg from '../../../../images/reviant.png';
import woodRocket from '../../../../images/wood_rocket.png';
import orangeRocket from '../../../../images/orange_rocket.png';
import lionRocket from '../../../../images/lion_rocket.png';
import hajper8 from '../../../../images/hajper_8.png';
import hajper12 from '../../../../images/hajper_12.png';
import hajper13 from '../../../../images/hajper_13.png';
import stugan8 from '../../../../images/stugan_8.png';
import stugan7 from '../../../../images/stugan_7.png';
import stugan9 from '../../../../images/stugan_9.png';
import stugan12 from '../../../../images/stugan_12.png';
import stugan13 from '../../../../images/stugan_13.png';
import stuganSurvivor6 from '../../../../images/stugan_survivor6.png';
import stuganSurvivor8 from '../../../../images/stugan_survivor8.png';
import snabbareSurvivor6 from '../../../../images/snabbare_survivor_6.png';
import snabbareSurvivor8 from '../../../../images/snabbare_survivor_8.png';
import hard13 from '../../../../images/hard_13.png';
import hard12 from '../../../../images/hard_12.png';
import hard8 from '../../../../images/hard_8.png';
import hard9 from '../../../../images/hard_hockey_9.png';
import hardSurvivor from '../../../../images/hard_survivor_65.png';

import unibet_football from '../../../../images/unibet_football.jpg';
import unibet_hockey from '../../../../images/unibet_hockey.png';
import { formatStringCurrency } from "../../../../common/CurrencyFormatter";
import { GetFlexNumber, GetJackpotString, GetMixMaxFlex, GetProPickLabel, gradientsC, IsLeo, IsOrangeLight, IsVideo, productNamesC, themeC } from "../../../../theme/themehelper";
import { DbetEightIcon, DbetEightLadder, DbetHockeyNineLogo, DbetSevenIcon, DbetSixIcon, DbetThirteenIcon, DbetThirteenLadder, DbetTwelveIcon, DbetTwelveLadder } from "../../../../images/dbeticons";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { UnibetInfoIcon, UnibetProPickIcon, UnibetSystemIcon } from '../../../../images/unibeticons';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Round } from "../../../../models/round";
import { ReactNode, useState, useEffect } from "react";

interface CouponHeaderSlimProps {
    jackpot: number | string;
    turnoverAmount: number | string;
    turnoverCurrency: string;
    round: Round;
    t: (key: string) => string;
    setShowRoundInfo: (show: boolean) => void;
    setShowProPick: (show: boolean) => void;
    setShowSystem: (show: boolean) => void;
    showRoundInfo: boolean;
    showProPick: boolean;
    showSystem: boolean;
}

function GoGoCountdown({ round, t }: { round: Round; t: (key: string) => string }) {
    const targetTime = new Date(round.openTo).getTime();
    const cutoff = new Date(Date.now());
    cutoff.setHours(cutoff.getHours() + 5);
    const showCountDown = new Date(round.openTo) < cutoff;

    const [timeLeft, setTimeLeft] = useState(targetTime - Date.now());

    useEffect(() => {
        if (!showCountDown) return;
        const id = setInterval(() => {
            setTimeLeft(targetTime - Date.now());
        }, 1000);
        return () => clearInterval(id);
    }, [targetTime, showCountDown]);

    const textStyle: React.CSSProperties = {
        fontFamily: (window.theme === themeC.Orange || window.theme === themeC.Lion) ? "'Roboto'" : "'Poppins'",
        fontWeight: (window.theme === themeC.Orange || window.theme === themeC.Lion) ? 700 : 400,
        fontSize: '10px',
        lineHeight: '10px',
        color: (window.theme === themeC.Orange || window.theme === themeC.Lion) ? '#1F1F1F' : '#F0F0F0',
    };

    if (!showCountDown) {
        return (
            <span style={{ ...textStyle, fontSize: '11px', lineHeight: '15px' }}>
                {getDateString(round as any, t)}
            </span>
        );
    }

    const total = Math.max(0, timeLeft);
    const hours = Math.floor(total / (1000 * 60 * 60)) % 24;
    const minutes = Math.floor(total / (1000 * 60)) % 60;
    const seconds = Math.floor(total / 1000) % 60;

    const pillStyle: React.CSSProperties = {
        background: window.theme === themeC.Lion ? '#FFF3F1' : window.theme === themeC.Orange ? '#FFF0E0' : 'rgba(0, 0, 0, 0.24)',
        borderRadius: '9px',
        padding: '3px 6px',
        display: 'inline-flex',
        alignItems: 'center',
    };

    const fmt = (n: number) => n.toString().padStart(2, '0');

    return (
        <Grid container alignItems="center" sx={{ gap: "2px", justifyContent: "center" }}>
            <Box sx={pillStyle}>
                <span style={textStyle}>{fmt(hours)}h</span>
            </Box>
            <span style={{ ...textStyle, padding: '0 1px' }}>:</span>
            <Box sx={pillStyle}>
                <span style={textStyle}>{fmt(minutes)}m</span>
            </Box>
            <span style={{ ...textStyle, padding: '0 1px' }}>:</span>
            <Box sx={pillStyle}>
                <span style={textStyle}>{fmt(seconds)}s</span>
            </Box>
        </Grid>
    );
}

function CouponHeaderSlim({
    jackpot,
    turnoverAmount,
    turnoverCurrency,
    round,
    t,
    setShowRoundInfo,
    setShowProPick,
    setShowSystem,
    showRoundInfo,
    showProPick,
    showSystem,
}: CouponHeaderSlimProps) {

    let roundImage: string = "";
    let roundLogo: string = "";
    let backgroundPosition: string = "-20px";
    let backgroundInfo: string = "var(--background_4)";

    let backgroundImageWidth: string = "145px";
    let backgroundImageHeight: string = (window.theme === themeC.GoGo || window.theme === themeC.Wood) ? "69px" : (window.theme === themeC.Orange || window.theme === themeC.Lion) ? "72px" : "71px";

    const startDate: Date = new Date(round.openTo);

    let minMaxFlexTextColor: string = 'var(--text-white)';
    let numberImage: string = "";
    let numberBackgroundHeight: string = "64px";
    let numberBackgroundWidth: string = "77px";
    let fontFamily: string = 'var(--font-title)';
    let numberIcon: ReactNode = "";

    const isAfterDeadline: boolean = startDate < new Date(Date.now());

    let mixMaxFlex: string = "";
    let number: string = GetFlexNumber(round.name);

    const smallText: SxProps<Theme> = {
        fontSize: "12px",
        color: "var(--text-black)",
        lineHeight: "18px",
        fontWeight: "400",
        fontFamily: "var(--font-body)",
    };

    const boldText: SxProps<Theme> = {
        fontSize: "16px",
        color: "var(--text-black)",
        lineHeight: "24px",
        fontWeight: "700",
        fontFamily: "var(--font-body)",
    };

    const mixMaxFlexStyle: Record<string, string | number> = {
        fontSize: "18px",
        fontFamily: 'var(--font-title)',
        color: 'var(--text-white)',
        fontWeight: "400",
        textTransform: "uppercase",
        marginTop: "0px"
    };

    if (window.theme === themeC.Orange) {
        roundImage = gradientsC.Orange.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
            roundImage = gradientsC.Orange.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
            roundImage = gradientsC.Orange.Mix;
        }
    }

    if (window.theme === themeC.GoGo) {
        roundImage = gradientsC.GoGo.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
            roundImage = gradientsC.GoGo.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
            roundImage = gradientsC.GoGo.Mix;
        }
    }

    if (window.theme === themeC.Wood) {
        roundImage = gradientsC.Wood.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
            roundImage = gradientsC.Wood.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
            roundImage = gradientsC.Wood.Mix;
        }
    }

    if (window.theme === themeC.Lion) {
        roundImage = gradientsC.Lion.Flex;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Orange.Hockey : productNamesC.Orange.Flex;
        mixMaxFlexStyle.textTransform = 'none';
        mixMaxFlexStyle.fontWeight = 600;

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Orange.Max;
            number = "13";
            roundImage = gradientsC.Lion.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Orange.Mix;
            number = "12";
            roundImage = gradientsC.Lion.Mix;
        }
    }

    if (window.theme === themeC.Green) {
        roundImage = round.name.indexOf("Hockey") > -1 ? `url(${unibet_hockey})` : `url(${unibet_football})`;
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? "Hockey" : "Rätt";
        mixMaxFlexStyle.fontFamily = 'UnibetPro';
        mixMaxFlexStyle.fontSize = '20px';
        backgroundImageHeight = '140px';
        (smallText as Record<string, string>).color = 'var(--font-color-supportive)';

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = round.name.indexOf("Hockey") > -1 ? "Hockey" : "Rätt";
            number = "13";
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = round.name.indexOf("Hockey") > -1 ? "Hockey" : "Rätt";
            number = "12";
        }
    }

    if (window.theme === themeC.ComeOn) {
        roundImage = `url(${comeon8})`;
        backgroundPosition = "-10px";
        backgroundImageHeight = "120px";
        mixMaxFlex = "";
        number = "";
        mixMaxFlexStyle.fontFamily = 'Gravity';

        if (round.name.indexOf("7") > -1) {
            roundImage = `url(${comeon7})`;
        }
        if (round.name.indexOf("9") > -1) {
            roundImage = `url(${comeon9})`;
        }

        if (round.name.indexOf("Max") > -1) {
            roundImage = `url(${comeon13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundImage = `url(${comeon12})`;
        }
    }

    if (window.theme === themeC.Hajper) {
        roundImage = `url(${hajper8})`;
        backgroundPosition = "-30px";
        mixMaxFlex = "";
        mixMaxFlexStyle.fontFamily = 'HajperDisplay';

        if (round.name.indexOf("Max") > -1) {
            number = "13";
            roundImage = `url(${hajper13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            number = "12";
            roundImage = `url(${hajper12})`;
        }
    }

    if (window.theme === themeC.Snabbare) {
        roundImage = `url(${snabbare8})`;
        backgroundPosition = "0px";
        backgroundImageHeight = "130px";
        mixMaxFlex = "";
        number = "";

        if (round.name.indexOf("7") > -1) {
            roundImage = `url(${snabbare7})`;
        }
        if (round.name.indexOf("9") > -1) {
            roundImage = `url(${snabbare9})`;
        }
        if (round.name.indexOf("Max") > -1) {
            roundImage = `url(${snabbare13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundImage = `url(${snabbare12})`;
        }
        if (round.name.indexOf("Survivor6") > -1) {
            roundImage = `url(${snabbareSurvivor6})`;
        }
        if (round.name.indexOf("Survivor8") > -1) {
            roundImage = `url(${snabbareSurvivor8})`;
        }
    }

    if (window.theme === themeC.Reviant) {
        roundImage = `url(${reviantBg})`;
        backgroundPosition = "0px";
        backgroundImageHeight = "90px";
        mixMaxFlex = productNamesC.ComeOn.Flex;
        mixMaxFlexStyle.color = "#E71F00";

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Max;
            number = "13";
        }
        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Mix;
            number = "12";
        }
    }

    if (window.theme === themeC.Lyllo) {
        roundImage = gradientsC.Lyllo.Flex;
        backgroundPosition = "0px";
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.ComeOn.Hockey : productNamesC.ComeOn.Flex;

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Max;
            number = "13";
            roundImage = gradientsC.Lyllo.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.ComeOn.Mix;
            number = "12";
            roundImage = gradientsC.Lyllo.Mix;
        }
    }

    if (window.theme === themeC.Stugan) {
        roundImage = `url(${stugan8})`;
        backgroundPosition = "0px";
        backgroundImageHeight = "130px";
        mixMaxFlex = "";
        number = "";

        if (round.name.indexOf("7") > -1) {
            roundImage = `url(${stugan7})`;
        }
        if (round.name.indexOf("9") > -1) {
            roundImage = `url(${stugan9})`;
        }
        if (round.name.indexOf("Max") > -1) {
            roundImage = `url(${stugan13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundImage = `url(${stugan12})`;
        }
        if (round.name.indexOf("Survivor6") > -1) {
            roundImage = `url(${stuganSurvivor6})`;
        }
        if (round.name.indexOf("Survivor8") > -1) {
            roundImage = `url(${stuganSurvivor8})`;
        }
    }

    if (window.theme === themeC.Kryss) {
        roundImage = gradientsC.Kryss.Flex;
        backgroundPosition = "0px";
        mixMaxFlex = round.name.indexOf("Hockey") > -1 ? productNamesC.Paf.Hockey : productNamesC.Paf.Flex;

        if (round.name.indexOf("Max") > -1) {
            mixMaxFlex = productNamesC.Paf.Max;
            number = "13";
            roundImage = gradientsC.Kryss.Max;
        }

        if (round.name.indexOf("Mix") > -1) {
            mixMaxFlex = productNamesC.Paf.Mix;
            number = "12";
            roundImage = gradientsC.Kryss.Mix;
        }
    }

    if (window.theme === themeC.Hard) {
        (smallText as Record<string, string>).color = 'var(--text-white)';
        (boldText as Record<string, string>).color = 'var(--text-white)';
        roundImage = round.name.indexOf("Hockey") > -1 ? `url(${hard9})` : `url(${hard8})`;
        backgroundPosition = "0px";
        mixMaxFlex = "";
        number = "";
        backgroundImageHeight = "150px";

        if (round.name.indexOf("Max") > -1) {
            roundImage = `url(${hard13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundImage = `url(${hard12})`;
        }
    }

    if (window.theme === themeC.Kung) {
        roundImage = gradientsC.Kung.Flex;
        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        minMaxFlexTextColor = "#27FFAA";
        numberImage = kung8;
        numberBackgroundHeight = "61px";
        numberBackgroundWidth = "46px";
        backgroundImageHeight = "90px";

        if (round.name.indexOf("Max") > -1) {
            number = "13";
            roundImage = gradientsC.Kung.Max;
            minMaxFlexTextColor = "#34C2FF";
            numberImage = kung13;
            numberBackgroundHeight = "64px";
            numberBackgroundWidth = "77px";
        }

        if (round.name.indexOf("Mix") > -1) {
            number = "12";
            roundImage = gradientsC.Kung.Mix;
            minMaxFlexTextColor = "#EE8DFF";
            numberImage = kung12;
            numberBackgroundHeight = "62px";
            numberBackgroundWidth = "77px";
        }
        numberImage = `url(${numberImage})`;
    }
    if (window.theme === themeC.Dbet) {
        roundImage = gradientsC.Dbet.Flex;
        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        minMaxFlexTextColor = "#F4C004";
        numberImage = "";
        numberBackgroundHeight = "61px";
        numberBackgroundWidth = "100px";
        backgroundImageHeight = "90px";
        fontFamily = "Righteous";
        numberIcon =
            <Grid container direction="row" alignItems="center" >
                <Grid sx={{ marginRight: "10px", paddingLeft: "25px" }}>
                    {DbetEightIcon()}
                </Grid>
                {DbetEightLadder()}
            </Grid>

        if (round.name.indexOf("Survivor6") > -1) {
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "10px", paddingLeft: "25px" }}>
                        {DbetSixIcon()}
                    </Grid>
                    {DbetEightLadder()}
                </Grid>
        }
        if (round.name.indexOf("Hockey7") > -1) {
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "10px", paddingLeft: "25px" }}>
                        {DbetSevenIcon()}
                    </Grid>
                    {DbetEightLadder()}
                </Grid>
        }
        if (round.name.indexOf("Hockey9") > -1) {
            mixMaxFlex = "";
            backgroundImageWidth = "262px";
            numberBackgroundHeight = "100px";
            numberBackgroundWidth = "262px";
            numberIcon =
                <Grid container alignItems="center" justifyContent="center" sx={{ height: "100%" }}>
                    {DbetHockeyNineLogo(30, 262)}
                </Grid>
        }


        if (round.name.indexOf("Max") > -1) {
            number = "13";
            roundImage = gradientsC.Dbet.Max;
            numberBackgroundHeight = "64px";
            numberBackgroundWidth = "130px";
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "10px", paddingLeft: "25px" }}>
                        {DbetThirteenIcon()}
                    </Grid>
                    {DbetThirteenLadder()}
                </Grid>
        }

        if (round.name.indexOf("Mix") > -1) {
            number = "12";
            roundImage = gradientsC.Dbet.Mix;
            numberBackgroundHeight = "62px";
            numberBackgroundWidth = "130px";
            numberIcon =
                <Grid container direction="row" alignItems="center" >
                    <Grid sx={{ marginRight: "10px", paddingLeft: "25px" }}>
                        {DbetTwelveIcon()}
                    </Grid>
                    {DbetTwelveLadder()}
                </Grid>
        }
        numberImage = `url(${numberImage})`;
    }

    if (window.theme === themeC.Video) {
        roundImage = `url(${video8back})`;
        roundLogo = video8;
        backgroundPosition = "0px";
        mixMaxFlex = GetMixMaxFlex(round.name, window.theme);
        minMaxFlexTextColor = "#7EFFB2";
        backgroundImageHeight = "122px";
        backgroundImageWidth = "294px";
        fontFamily = "Tilt Warp";

        if (round.name.indexOf("Max") > -1) {
            roundImage = `url(${video13back})`;
            roundLogo = video13;
            minMaxFlexTextColor = "#FFF3B7";
        }

        if (round.name.indexOf("Mix") > -1) {
            roundImage = `url(${video12back})`;
            roundLogo = video12;
            minMaxFlexTextColor = "#D47EDD";
        }
    }

    if (window.theme === themeC.MrVegas) {
        roundImage = `url(${mrvegas8back})`;
        roundLogo = mrvegas8;
        backgroundPosition = "0px";
        mixMaxFlex = "";
        minMaxFlexTextColor = "#7EFFB2";
        backgroundImageHeight = "122px";
        backgroundImageWidth = "294px";

        if (round.name.indexOf("Max") > -1) {
            roundImage = `url(${mrvegas13back})`;
            roundLogo = mrvegas13;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundImage = `url(${mrvegas12back})`;
            roundLogo = mrvegas12;
        }
    }

    if (window.theme === themeC.Mega) {
        roundImage = `url(${mega8})`;
        backgroundPosition = "0px";
        mixMaxFlex = "";
        minMaxFlexTextColor = "#7EFFB2";
        backgroundImageHeight = "135px";

        if (round.name.indexOf("Max") > -1) {
            roundImage = `url(${mega13})`;
        }

        if (round.name.indexOf("Mix") > -1) {
            roundImage = `url(${mega12})`;
        }
    }

    const isGoGo = window.theme === themeC.GoGo || window.theme === themeC.Wood || window.theme === themeC.Orange || window.theme === themeC.Lion;
    const isOrangeLight = IsOrangeLight(window.theme);
    const accentColor = window.theme === themeC.GoGo ? '#F14AA7' : window.theme === themeC.Orange ? '#FE8000' : window.theme === themeC.Lion ? '#FD5C3C' : '#B19661';
    const accentHover = window.theme === themeC.GoGo ? '#D93D96' : window.theme === themeC.Orange ? '#FE9326' : window.theme === themeC.Lion ? '#E04E33' : '#c8b690';
    const headerFont = window.theme === themeC.GoGo ? "'Poppins'" : window.theme === themeC.Orange ? "'Hind'" : window.theme === themeC.Lion ? "'Roboto'" : "'GT-America'";
    const headerFontWeight = window.theme === themeC.GoGo ? 400 : (window.theme === themeC.Orange || window.theme === themeC.Lion) ? 700 : 500;

    const chipStyle: SxProps<Theme> = isGoGo ? {
        padding: '7px 14px',
        fontSize: '14px',
        fontFamily: headerFont,
        fontWeight: (window.theme === themeC.Orange || window.theme === themeC.Lion) ? 400 : headerFontWeight,
        color: (window.theme === themeC.Lion || isOrangeLight) ? '#636363' : '#B3B3B3',
        backgroundColor: (window.theme === themeC.Lion || isOrangeLight) ? '#FFFFFF' : undefined,
        borderColor: (window.theme === themeC.Lion || isOrangeLight) ? '#DDDDDD' : '#575757',
        borderRadius: '500px',
        '& .MuiChip-icon': { display: (window.theme === themeC.Orange || window.theme === themeC.Lion) ? 'none' : undefined, marginLeft: 0, marginRight: '6px' },
        '& .MuiChip-label': { padding: 0 },
    } : {
        padding: '5px 5px',
        fontSize: '12px',
        color: "var(--text-black-dark-background)"
    };

    const chipStyleSelected: SxProps<Theme> = isGoGo ? {
        padding: '7px 14px',
        fontSize: '14px',
        fontFamily: headerFont,
        fontWeight: (window.theme === themeC.Orange || window.theme === themeC.Lion) ? 400 : headerFontWeight,
        color: (window.theme === themeC.Lion || isOrangeLight) ? '#FFFFFF' : '#0C0C0C',
        backgroundColor: window.theme === themeC.Lion ? '#FD5C3C' : isOrangeLight ? '#1F1F1F' : accentColor,
        borderColor: window.theme === themeC.Lion ? '#FD5C3C' : isOrangeLight ? '#1F1F1F' : accentColor,
        borderRadius: '500px',
        '& .MuiChip-icon': { display: (window.theme === themeC.Orange || window.theme === themeC.Lion) ? 'none' : undefined, marginLeft: 0, marginRight: '6px' },
        '& .MuiChip-label': { padding: 0 },
        '&:hover': { backgroundColor: `${window.theme === themeC.Lion ? '#E04E33' : isOrangeLight ? '#333333' : accentHover} !important` }
    } : {
        padding: '5px 5px',
        fontSize: '12px',
        color: 'var(--button-text-color)',
        backgroundColor: "var(--button-color)",
        borderColor: "var(--button-color)",
        transition: 'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
            backgroundColor: 'var(--button-hover-color) !important'
        }
    };

    const iconStyle = {
        color: "var(--text-black-dark-background)"
    };

    const iconStyleSelected = {
        color: 'var(--button-text-color)',
    };

    if (window.theme === themeC.MrVegas || window.theme === themeC.Mega) {
        (smallText as Record<string, string>).color = "var(--font-color-supportive)";
    }

    const setPro = (show: boolean): void => {
        setShowProPick(show);
        if (show) {
            setShowRoundInfo(false);
            setShowSystem(false);
        }
    };

    if (round.name.indexOf("Survivor") > -1) {
        mixMaxFlex = (window as any).theme === themeC.Green ? 'Stegen' : ((window as any).theme === themeC.Hajper ? '' : t('survivor8'));
        number = GetFlexNumber(round.name);
    }

    // Wood survivor uses the rocket artwork as the header background.
    if (round.name.indexOf("Survivor") > -1 && (window as any).theme === themeC.Wood) {
        roundImage = `url(${woodRocket})`;
    }
    const isWoodSurvivor = round.name.indexOf("Survivor") > -1 && window.theme === themeC.Wood;

    // Orange survivor uses the rocket artwork as the header background.
    if (round.name.indexOf("Survivor") > -1 && (window as any).theme === themeC.Orange) {
        roundImage = `url(${orangeRocket})`;
    }
    const isOrangeSurvivor = round.name.indexOf("Survivor") > -1 && window.theme === themeC.Orange;

    // Lion survivor uses the rocket artwork as the header background.
    if (round.name.indexOf("Survivor") > -1 && (window as any).theme === themeC.Lion) {
        roundImage = `url(${lionRocket})`;
    }
    const isLionSurvivor = round.name.indexOf("Survivor") > -1 && window.theme === themeC.Lion;

    // Specific overrides: stugan's tile has "Tipsraketen" + number baked in, so suppress the overlay text to avoid drawing it twice.
    if (round.name.indexOf("Survivor") > -1 && (window as any).theme === themeC.Stugan) {
        mixMaxFlex = "";
        number = "";
    }

    if (round.name.indexOf("Survivor") > -1 && (window as any).theme === themeC.Snabbare) {
        mixMaxFlex = "";
        number = "";
    }

    // Hard/Bethard survivor uses the Tipsraketen plate as the header background.
    // "Tipsraketen" is baked in and the plate has no round number; blank both.
    if (round.name.indexOf("Survivor") > -1 && (window as any).theme === themeC.Hard) {
        roundImage = `url(${hardSurvivor})`;
        mixMaxFlex = "";
        number = "";
    }
    const isHardSurvivor = round.name.indexOf("Survivor") > -1 && window.theme === themeC.Hard;

    const setRound = (show: boolean): void => {
        setShowRoundInfo(show);
        if (show) {
            setShowProPick(false);
            setShowSystem(false);
        }
    };

    const setSystem = (show: boolean): void => {
        setShowSystem(show);
        if (show) {
            setShowProPick(false);
            setShowRoundInfo(false);
        }
    };

    return (
        <Grid container direction='column' alignItems='center' sx={(window.theme === themeC.Green || window.theme === themeC.Lion) ? { backgroundColor: '#ffffff' } : {}}>
            <Grid item sx={{
                padding: (window.theme === themeC.GoGo || window.theme === themeC.Wood || window.theme === themeC.Orange || window.theme === themeC.Lion) ? '12px' : (window.theme === themeC.Green ? '0px' : '15px'),
                width: '100%',
                backgroundImage: roundImage,
                backgroundSize: (window.theme === themeC.Green && round.name.indexOf("Hockey") > -1) ? '110% auto' : (window.theme === themeC.Green ? '160% auto' : (isWoodSurvivor || isOrangeSurvivor || isLionSurvivor) ? '100% auto' : 'cover'),
                backgroundPosition: (window.theme === themeC.Green && round.name.indexOf("Hockey") > -1) ? '-28px -73px' : (window.theme === themeC.Green ? 'center 64%' : (isWoodSurvivor || isOrangeSurvivor || isLionSurvivor) ? 'right bottom' : isHardSurvivor ? 'center' : undefined),
                backgroundPositionY: (window.theme === themeC.Green && round.name.indexOf("Hockey") > -1) ? undefined : (window.theme === themeC.Green || window.theme === themeC.Lion || isWoodSurvivor || isOrangeSurvivor || isLionSurvivor || isHardSurvivor ? undefined : backgroundPosition),
                backgroundRepeat: (isWoodSurvivor || isOrangeSurvivor || isLionSurvivor) ? 'no-repeat' : undefined,
                borderTopLeftRadius: 'var(--radius)',
                borderTopRightRadius: 'var(--radius)',
                position: window.theme === themeC.Green ? 'relative' : undefined,
                overflow: window.theme === themeC.Green ? 'hidden' : undefined,
            }}>
                {window.theme === themeC.Green &&
                    <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: round.name.indexOf('Hockey') > -1 ? 'linear-gradient(0deg, rgba(14, 60, 22, 0.25) 75%, rgba(62, 171, 55, 0.125) 100%)' : 'linear-gradient(180deg, rgba(14, 60, 22, 0.5) 30%, rgba(62, 171, 55, 0.5) 100%)' }} />
                }
                <Grid container direction='column' alignItems='center'                    >
                    <Grid item sx={{
                        width: (window.theme === themeC.GoGo || window.theme === themeC.Wood || window.theme === themeC.Orange || window.theme === themeC.Lion) ? '100%' : backgroundImageWidth,
                        height: backgroundImageHeight,
                        backgroundImage: `url(${roundLogo})`,
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    }}>

                        {(window.theme === themeC.GoGo || window.theme === themeC.Wood || window.theme === themeC.Orange || window.theme === themeC.Lion) &&
                            <Grid direction="column" container alignItems="center" justifyContent="center" sx={{ gap: "8px", height: "100%" }}>
                                <Typography sx={{
                                    fontFamily: headerFont,
                                    fontWeight: headerFontWeight,
                                    fontSize: window.theme === themeC.Lion ? '18px' : '16px',
                                    lineHeight: '24px',
                                    color: (window.theme === themeC.Orange || window.theme === themeC.Lion) ? '#FFFFFF' : '#F0F0F0',
                                    textTransform: 'uppercase',
                                }}>
                                    {mixMaxFlex} {number}
                                </Typography>
                                {!isAfterDeadline ? (
                                    <Grid container alignItems="center" sx={{ gap: "4px", justifyContent: "center" }}>
                                        {window.theme !== themeC.Lion && (
                                            <span style={{ fontFamily: headerFont, fontWeight: headerFontWeight, fontSize: '10px', lineHeight: '15px', color: window.theme === themeC.Orange ? (isOrangeSurvivor ? '#FFFFFF' : '#1F1F1F') : '#F0F0F0' }}>
                                                {t('starts')}
                                            </span>
                                        )}
                                        <GoGoCountdown round={round} t={t} />
                                    </Grid>
                                ) : (
                                    <Grid container alignItems="center" sx={{ gap: "4px", justifyContent: "center" }}>
                                        <span style={{ fontFamily: headerFont, fontWeight: headerFontWeight, fontSize: '10px', lineHeight: '15px', color: window.theme === themeC.Orange ? (isOrangeSurvivor ? '#FFFFFF' : '#1F1F1F') : '#F0F0F0' }}>
                                            {t('started')} {getDateString(round, t)}
                                        </span>
                                    </Grid>
                                )}
                            </Grid>
                        }

                        {(IsLeo(window.theme)) && window.theme !== themeC.GoGo && window.theme !== themeC.Wood && window.theme !== themeC.Orange && window.theme !== themeC.Lion && window.theme !== themeC.Green &&
                            <Grid direction="column" container alignItems="center" sx={{ marginTop: "-5px" }}>
                                <Typography sx={mixMaxFlexStyle}>
                                    {mixMaxFlex}
                                </Typography>
                                <Typography sx={{
                                    fontSize: window.theme === themeC.Hajper ? "70px" : "60px",
                                    fontFamily: mixMaxFlexStyle.fontFamily,
                                    color: window.theme === themeC.Hard ? 'var(--button-text-color)' : (window.theme === themeC.Reviant ? '#E71F00' : 'var(--text-white)'),
                                    fontWeight: "800",
                                    marginTop: window.theme === themeC.Hajper ? "-15px" : "-17px"
                                }}>
                                    {number}
                                </Typography>

                                {window.theme === themeC.Hajper && round.name.indexOf("Hockey") === -1 && round.name.indexOf("Survivor") === -1 &&
                                    <Typography sx={{ fontWeight: 500, fontSize: "14px", marginTop: "-25px" }}>
                                        Matcher
                                    </Typography>
                                }
                                {window.theme === themeC.Hajper && round.name.indexOf("Hockey") > -1 &&
                                    <Typography sx={{ fontWeight: 500, fontSize: "14px", marginTop: "-25px" }}>
                                        Hockey
                                    </Typography>
                                }
                                {window.theme === themeC.Hajper && round.name.indexOf("Survivor") > -1 &&
                                    <Typography sx={{ fontWeight: 500, fontSize: "14px", marginTop: "-25px" }}>
                                        {t('survivor8')}
                                    </Typography>
                                }
                            </Grid>
                        }
                        {window.theme === themeC.Green &&
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', gap: '4px', position: 'relative' }}>
                                <Typography sx={{
                                    fontFamily: 'UnibetPro',
                                    fontStyle: 'normal',
                                    fontWeight: 500,
                                    fontSize: '80px',
                                    lineHeight: '52px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    textAlign: 'right',
                                    color: '#FFFFFF',
                                    position: 'relative',
                                }}>
                                    {number}
                                </Typography>
                                <Typography sx={{
                                    fontFamily: 'UnibetPro',
                                    fontWeight: 500,
                                    fontSize: '20px',
                                    color: '#FFFFFF',
                                    textTransform: 'uppercase',
                                    position: 'relative',
                                }}>
                                    {mixMaxFlex}
                                </Typography>
                            </Box>
                        }

                        {IsVideo(window.theme) &&
                            <Grid direction="column" container alignItems="center" sx={{ marginTop: "-5px" }}>
                                <Typography sx={{
                                    fontSize: "20px",
                                    fontFamily: fontFamily,
                                    color: minMaxFlexTextColor,
                                    fontWeight: window.theme === themeC.Kung ? "700" : "400",
                                    textTransform: window.theme === themeC.Video ? "none" : "uppercase",
                                    marginTop: "0px"
                                }}>
                                    {mixMaxFlex}
                                </Typography>
                                <Box
                                    sx={{
                                        backgroundImage: numberImage,
                                        backgroundSize: "contain",
                                        backgroundRepeat: "no-repeat",
                                        height: numberBackgroundHeight,
                                        width: numberBackgroundWidth,
                                    }}
                                >
                                    {numberIcon}
                                </Box>
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
            {isGoGo ? (
                <Grid container direction='row' justifyContent='center' alignItems='center' sx={{ padding: '12px', background: (window.theme === themeC.Lion || isOrangeLight) ? '#FFFFFF' : '#121212', width: '100%', gap: '8px', minHeight: '64px' }}>
                    <Grid item sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography sx={{ fontFamily: headerFont, fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: (window.theme === themeC.Lion || isOrangeLight) ? '#636363' : '#B3B3B3', textAlign: 'center' }}>{isAfterDeadline ? t('status') : GetJackpotString(window.theme, t, false, round.fixtures.length)}</Typography>
                        <Typography sx={{ fontFamily: headerFont, fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: (window.theme === themeC.Lion || isOrangeLight) ? '#1F1F1F' : '#F0F0F0', textAlign: 'center' }}>{isAfterDeadline ? getRoundStatus(round, startDate, t) : formatStringCurrency(jackpot, turnoverCurrency, t, true)}</Typography>
                    </Grid>
                    <Grid item sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography sx={{ fontFamily: headerFont, fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: (window.theme === themeC.Lion || isOrangeLight) ? '#636363' : '#B3B3B3', textAlign: 'center' }}>{t('turnover')}</Typography>
                        <Typography sx={{ fontFamily: headerFont, fontWeight: 400, fontSize: '14px', lineHeight: '20px', color: (window.theme === themeC.Lion || isOrangeLight) ? '#1F1F1F' : '#F0F0F0', textAlign: 'center' }}>{formatStringCurrency(turnoverAmount, turnoverCurrency, t, true)}</Typography>
                    </Grid>
                </Grid>
            ) : (
            <Grid container direction='column' alignItems='center' sx={{ padding: '10px', background: backgroundInfo, width: '100%' }}>
                {!isAfterDeadline &&
                    <Grid item>
                        <Grid container direction="column" alignItems='center' sx={{ marginTop: '10px', marginBottom: '0px' }}>
                            <Typography sx={smallText}>{GetJackpotString(window.theme, t, false, round.fixtures.length)}</Typography>
                            <Typography sx={boldText}>{formatStringCurrency(jackpot, turnoverCurrency, t, true)}</Typography>
                        </Grid>
                    </Grid>
                }
                {isAfterDeadline &&
                    <Grid item sx={{ position: 'relative' }}>
                        {round.status === 'ACTIVE' &&
                            <Box sx={{
                                position: 'absolute',
                                left: '-120px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                backgroundColor: '#e53935',
                                color: '#fff',
                                borderRadius: '4px',
                                padding: '2px 8px',
                                fontSize: '11px',
                                fontWeight: 700,
                                fontFamily: 'var(--font-title)',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                            }}>
                                {t('live')}
                            </Box>
                        }
                        <Grid container direction="column" alignItems='center' sx={{ marginTop: '10px', marginBottom: '0px' }}>
                            <Typography sx={smallText}>{t('status')}</Typography>
                            <Typography sx={boldText}>{getRoundStatus(round, startDate, t)}</Typography>
                        </Grid>
                    </Grid>
                }
                <Grid container justifyContent='space-evenly' sx={{ marginTop: '5px' }}>
                    <Grid item>
                        <Grid container direction='column' alignItems='center'>
                            <Typography sx={smallText}>{t('turnover')}</Typography>
                            <Typography sx={boldText}>{formatStringCurrency(turnoverAmount, turnoverCurrency, t, true)}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='column' alignItems='center'>
                            <Typography sx={smallText}>{isAfterDeadline ? t('started') : (window.theme === themeC.Kryss ? t('starts_kryss') : t('starts'))}</Typography>
                            <Typography sx={boldText}>{getDateString(round, t)}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            )}
            {!isAfterDeadline &&
                <Grid container justifyContent="space-evenly" sx={isGoGo ? { padding: '12px', gap: '8px', borderBottom: (window.theme === themeC.Lion || isOrangeLight) ? '1px solid #DDDDDD' : '1px solid #575757', marginTop: '0px', marginBottom: '0px', background: (window.theme === themeC.Lion || isOrangeLight) ? '#F6F6F6' : '#121212', width: '100%' } : { marginTop: '0px', marginBottom: '0px', paddingBottom: '10px', background: backgroundInfo, width: '100%' }}>

                    <Chip label={t('round_information_short')} icon={window.theme === themeC.Green ? <UnibetInfoIcon width={20} height={20} fill={showRoundInfo ? iconStyleSelected.color as any : iconStyle.color as any} /> : <InfoOutlinedIcon fontSize="small" color={showRoundInfo ? iconStyleSelected.color as any : iconStyle.color as any} />}
                        variant="outlined" onClick={() => setRound(true)} sx={showRoundInfo ? chipStyleSelected : chipStyle} />

                    <Chip label={GetProPickLabel(window.theme, t)} icon={window.theme === themeC.Green ? <UnibetProPickIcon width={20} height={20} fill={showProPick ? iconStyleSelected.color as any : iconStyle.color as any} /> : <PersonOutlineOutlinedIcon fontSize="small" color={showProPick ? iconStyleSelected.color as any : iconStyle.color as any} />} variant="outlined" onClick={() => setPro(true)}
                        sx={showProPick ? chipStyleSelected : chipStyle} />

                    {round?.fixtures?.length > 9 &&
                        <Chip label={t('system')} icon={window.theme === themeC.Green ? <UnibetSystemIcon width={20} height={20} fill={showSystem ? iconStyleSelected.color as any : iconStyle.color as any} /> : <SettingsOutlinedIcon fontSize="small" color={showSystem ? iconStyleSelected.color as any : iconStyle.color as any} />} variant="outlined" onClick={() => setSystem(true)}
                            sx={showSystem ? chipStyleSelected : chipStyle} />
                    }
                </Grid>
            }
        </Grid>

    );
}

export default CouponHeaderSlim;
